import storage from "redux-persist/lib/storage";

/**
 * What survives a reload from the `sideMenu` slice (CTX-639).
 *
 * Its own module, not an object inside `store.tsx`, so the rule can be asserted
 * without instantiating the whole store — every other reducer, and the
 * redux-persist bootstrap, would come along for the ride.
 *
 * `isExpanded` is a preference: the rail now opens collapsed, and a person who
 * opens it should find it open next time. `isMobileMenuOpen` is not — a drawer
 * that reopens itself on load is a bug wearing a preference's clothes, which is
 * why this is a nested config rather than `sideMenu` on the root whitelist.
 * Anything added to the slice later is NOT persisted unless it is named here.
 */
export const sideMenuPersistConfig = {
  key: "sideMenu",
  storage,
  whitelist: ["isExpanded"] as const,
};
